import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import ColorContext from '@providers/ColorProvider/context/ColorContext';
import { ReactNode, useContext } from 'react';

interface Props {
    children?: ReactNode;
    warmIcon?: ReactNode;
    coolIcon?: ReactNode;
    fit?: boolean;
    subTitle?: string;
}

function BlankContainer({
  children, warmIcon, coolIcon, fit, subTitle,
}:Props) {
  const { grayTheme } = useContext(ColorContext);
  return (
        <Column align='center' fullWidth justify='center'
                style={{ minHeight: fit ? 'unset' : '50vh', rowGap: 14 }}>
            {grayTheme === 'WARM' ? warmIcon : coolIcon}
            <Column align='center' spacing={4}>
                {subTitle && (
                    <Text color={colors.gray6} size='lg' fontWeight='medium'>{subTitle}</Text>
                )}
                <Text color={colors.gray6}>
                    {children}
                </Text>
            </Column>

        </Column>
  );
}

export default BlankContainer;
